import { createContext, useContext } from 'react';
import type { useGuiaInteractiva } from '@/features/guia-interactiva/hooks/use-guia-interactiva';

type GuiaInteractivaContextValue = ReturnType<typeof useGuiaInteractiva>;

export const GuiaInteractivaContext = createContext<GuiaInteractivaContextValue | null>(null);

export function useGuiaInteractivaContext(): GuiaInteractivaContextValue {
  const ctx = useContext(GuiaInteractivaContext);
  if (!ctx) {
    throw new Error('useGuiaInteractivaContext debe usarse dentro de <GuiaInteractivaProvider>.');
  }
  return ctx;
}
